// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust path to your firebase.js

// 1. Create the Context
const AuthContext = createContext();

// 2. A custom hook so other files can easily use this context
export function useAuth() {
  return useContext(AuthContext);
}

// 3. The Provider Component that wraps your app
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Prevents app from flashing before checking auth

  useEffect(() => {
    // This is the MAGIC Firebase function. 
    // It automatically runs when the app loads, and whenever the user logs in or out.
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
       if (user) {
      await user.reload();
      setCurrentUser({ ...auth.currentUser });
    } else {
      setCurrentUser(null);
    }
      setLoading(false); // We got the answer, stop loading
    });

    // Cleanup the listener when component unmounts
    return unsubscribe;
  }, []);

  // Provide a global logout function
  const logout = () => {
    return signOut(auth);
  };

  const value = {
    currentUser,
    logout
  };

  // Don't render the app until Firebase has confirmed the session status
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}